import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "minibus"
const MinibusIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.513 6.938C18.03 6.938 18.5 7.243 18.712 7.717L19.913 10.419 21.16 10.835C21.848 11.065 22.313 11.709 22.313 12.435V16.126C22.313 16.643 21.893 17.063 21.375 17.063H19.635C19.155 17.636 18.433 18 17.626 18S16.096 17.636 15.615 17.063H8.385C7.905 17.636 7.183 18 6.376 18S4.846 17.636 4.365 17.063H2.624C2.107 17.063 1.688 16.643 1.688 16.125V11.55L2.638 8.062H2.25C1.94 8.063 1.688 7.812 1.688 7.5 1.688 7.19 1.939 6.938 2.25 6.938zM6.375 14.25C5.754 14.25 5.25 14.754 5.25 15.375S5.754 16.5 6.375 16.5 7.5 15.996 7.5 15.375 6.996 14.25 6.375 14.25M17.625 14.25C17.004 14.25 16.5 14.754 16.5 15.375S17.004 16.5 17.625 16.5 18.75 15.996 18.75 15.375 18.246 14.25 17.625 14.25M2.813 11.7V13.313H3.375C3.685 13.313 3.938 13.564 3.938 13.875 3.938 14.185 3.686 14.438 3.375 14.438H2.813V15.938H3.812Q3.75 15.665 3.75 15.375C3.75 13.925 4.925 12.75 6.375 12.75S9 13.925 9 15.375Q8.999 15.665 8.938 15.938H15.062Q15 15.665 15 15.375C15 13.925 16.175 12.75 17.625 12.75S20.25 13.925 20.25 15.375Q20.249 15.665 20.189 15.938H21.188V14.438H21C20.69 14.438 20.438 14.186 20.438 13.875S20.689 13.313 21 13.313H21.188V12.436C21.188 12.194 21.033 11.978 20.803 11.902L19.408 11.438H4.549L5.3 8.062H3.804zM5.951 10.313H8.438V8.063H6.45zM9.562 10.313H13.313V8.063H9.563zM14.439 10.313H18.633L17.684 8.172C17.654 8.107 17.587 8.064 17.513 8.064H14.437z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MinibusIcon
